import { escapeRegExp } from 'lodash';
export const FilterRe = (value) => new RegExp(`${escapeRegExp(value)}`, 'i');
